import { useMemo } from 'react';
import useAdminSessions, { type AdminSession } from './useAdminSessions.ts';

export type AdminEscalation = AdminSession;

const useAdminEscalations = () => {
  const query = useAdminSessions();

  const escalations = useMemo(
    () => (query.data ?? []).filter((s) => s.has_pending_escalation),
    [query.data],
  );

  return { ...query, data: escalations };
};

export default useAdminEscalations;
